import React from 'react';
import { Box, Stack, StackProps, Typography } from '@mui/material';

const stackProps: StackProps = {
  flexDirection: 'column',
  justifyContent: 'center',
  alignItems: 'center',
  textAlign: 'center',
  style: {
    height: 'calc(100vh - 64px)',
    padding: '0 15px',
  },
};

const ProcessingView: React.FC = () => {
  return (
    <Stack {...stackProps}>
      <img
        src={`${process.env.PUBLIC_URL}/images/payment/payment-processing.png`}
        alt="payment-processing"
        width="100%"
        style={{ maxWidth: '300px' }}
      />
      <div>
        <Typography variant="h6">Payment Processing</Typography>
      </div>
      <div>
        <Typography color="secondary">
          We&apos;re processing your credit card. This process may take a few
          <Box component="br" sx={{ display: { xs: 'none', sm: 'block' } }} />
          seconds, So please be patient.
        </Typography>
      </div>
    </Stack>
  );
};

export default ProcessingView;
